import { render, staticRenderFns } from "./pcHeader.vue?vue&type=template&id=06ff0822&"
import script from "./pcHeader.vue?vue&type=script&lang=js&"
export * from "./pcHeader.vue?vue&type=script&lang=js&"
import style0 from "./pcHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports